// Anchors (Oct 2026): who may / should work a location, held by STAFF ID.
//
//   preferences[location] = { global: [ids], "<weekday>_<AM|PM>": [ids] }
//
// The session keys are built here and looked up in a fixed table -- never
// split apart -- and the lists hold ids, never names (a name with a comma used
// to become two people when the old comma-separated shape was split).

export const ALL_DAYS = 'global';
const HALVES = ['AM', 'PM'];

// The 14 valid session keys, and what each one means.
const SESSIONS = new Map();
for (let day = 0; day < 7; day += 1) {
  HALVES.forEach(half => SESSIONS.set(`${day}_${half}`, { day, half }));
}

/** The key for one session (weekday 0-6, "AM"/"PM"), or all days when no day is given. */
export function sessionKey(day = null, half = null) {
  if (day === null || day === undefined) return ALL_DAYS;
  const key = `${day}_${half}`;
  return SESSIONS.has(key) ? key : null;
}

/** {day, half} for a session key; null for the all-days key or anything unknown. */
export const sessionOf = (key) => SESSIONS.get(key) || null;

/** An entry's lists, copied; anything that is not a list of ids is dropped. */
export function copyEntry(entry) {
  const out = {};
  if (entry && typeof entry === 'object' && !Array.isArray(entry)) {
    Object.entries(entry).forEach(([key, ids]) => {
      if ((key === ALL_DAYS || SESSIONS.has(key)) && Array.isArray(ids)) out[key] = ids.filter(Boolean);
    });
  }
  return out;
}

/** Every staff id the entry names, all days and per session, once each. */
export function anchorIdsOf(entry) {
  const all = new Set();
  Object.values(copyEntry(entry)).forEach(ids => ids.forEach(id => all.add(id)));
  return all;
}
